import styled from 'styled-components';

export const AccordingContainer = styled.div`
background: #F0FFE6;
width: 100%;
`;

export const AccordingWrapper = styled.div`
display: flex;
width: 100%;
max-width: 1400px;
margin-left: auto;
margin-right: auto;
padding: 0 25px;
`;

export const ContentWrapper = styled.div`
display: grid;
grid-template-columns: 1fr 2fr;
width: 100%;
padding: 25px;
border-radius: 10px;
background: linear-gradient( to right, rgba(51, 104, 44, 0.2) 0%, rgba(51, 104, 44, 1) 40%), url(${({ Bg }) => (Bg)});
background-repeat: no-repeat;
background-size: cover;

@media screen and (max-width: 1100px){
    grid-template-columns: 1fr;
    background: linear-gradient( to bottom, rgba(51, 104, 44, 0.2) 0%, rgba(51, 104, 44, 1) 40%), url(${({ Bg }) => (Bg)});
}
`;

export const TextWrapper = styled.div`
display: flex;
flex-direction: column;
margin-top: auto;
margin-bottom: auto;
`;

export const AccordingText = styled.p`
font-size: 18px;
color: #fff;

@media screen and (max-width: 768px){
    font-size: 14px;
}

@media screen and (max-width: 480px){
    font-size: 12px;
}
`;

export const AccordingText2 = styled.p`
font-size: 18px;
color: #fff;
margin-top: 25px;

@media screen and (max-width: 768px){
    font-size: 14px;
}

@media screen and (max-width: 480px){
    font-size: 12px;
}
`;

export const AccordingImage = styled.img`
width: 100%;
max-width: 300px;
height: auto;
margin-top: auto;
margin-bottom: auto;
margin-left: auto;
margin-right: auto;
padding: 25px;

@media screen and (max-width: 1100px){
    max-width: 200px;
}
`;
